export const getInfinityQuery = async (
  query,
  pageParam = 1,
  id,
  limit = 12
) => {
  const res = await query({ page: pageParam, id, limit })
  const data = {
    results: res.items ?? res,
    next: res.countOfPages === pageParam ? undefined : pageParam + 1,
  }

  return data
}
